import moment from "moment-timezone";
import { Col, Row } from "react-bootstrap";
import { useLookupTaxQuery } from "../../../Redux/Services/lookupApi";
import Loading from "../../Infrastructure/Loading";

export default function TaxSummary({
  boro,
  block,
  lot,
  easement,
}: {
  boro: string;
  block: string;
  lot: string;
  easement: string | undefined;
}) {
  const { data, isLoading } = useLookupTaxQuery({
    boro,
    block,
    lot,
    easement: easement || "",
  });
  if (isLoading) return <Loading />;
  if (!data) return <div>data is undefined</div>;
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Year</th>
            <th>Type</th>
            <th>Due Date</th>
            <th>Charge</th>
            <th>Paid</th>
            <th>Balance</th>
            <th className="mobile-only">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {data.data.map((row, i) => (
            <tr key={i}>
              <td>
                {row.year} Q{row.period}
              </td>
              <td>{row.chargeType}</td>
              <td>
                {moment(row.originalDueDate, "MM/DD/YYYY").format("YYYY-MM-DD")}
              </td>
              <td>{row.charge}</td>
              <td>{row.paid}</td>
              <td>{row.balance}</td>
              <td className="mobile-only">
                <Row>
                  <Col xs={4}>
                    <dt>Period:</dt>
                    <dd>
                      {row.year} Q{row.period}
                    </dd>
                  </Col>
                  <Col xs={4}>
                    <dt>Type:</dt>
                    <dd>{row.chargeType}</dd>
                  </Col>
                  <Col xs={4}>
                    <dt>Due Date:</dt>
                    <dd>
                      {moment(row.originalDueDate, "MM/DD/YYYY").format(
                        "YYYY-MM-DD",
                      )}
                    </dd>
                  </Col>
                  <Col xs={4}>
                    <dt>Charge:</dt>
                    <dd>{row.charge}</dd>
                  </Col>
                  <Col xs={4}>
                    <dt>Paid:</dt>
                    <dd>{row.paid}</dd>
                  </Col>
                  <Col xs={4}>
                    <dt>Balance:</dt>
                    <dd>{row.balance}</dd>
                  </Col>
                </Row>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
